var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceArrowBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.69,15.75c0.1-0.21,1.01-0.13,1.75-0.21c3.17-0.35,2.81-1.04,3.58-1.64c0.93-1.51,0.54-1.49,1.17-2.5 c0.13-0.2-0.1,0.22,0,0c0.4-0.81-0.24,0.78,0.03,0.42c0.17-0.24-0.01,0.17-0.01,0.17l-5.38-0.02c0,0-1.15,0.22-0.72-0.17L-0.34,8.3 c0.23-0.2,1.9-0.08,1.9-0.08l4.3-0.1c0,0-0.29-0.49,0.13,0.24c0.1,0.18-0.24-0.48-0.84-1.38C5.07,6.86,4.78,6.63,4.71,6.51 c-0.64-1.02-1.08-1.25-1.82-1.9c-0.72-0.64-1.9-0.53-3.21-0.6C-0.51,4-0.39,2.94-0.45,2.68l-0.09-2.08c0.21-0.2,2.75,0.46,3.24,0.59 C3.52,1.4,2.84,1.23,5,1.99c0.95,0.85,1.68,1.89,2.3,2.88c0.08,0.12,0.36,0.49,0.43,0.61c0.97,1.09,1.41,1.63,2.14,2.54 c0.94,0.68,2.38,0.36,4.15,0.35c0.34,0,0.28,0.43-0.57,0.29l-0.64-3.9c0.12-0.03-0.22-0.61,0.4-0.55l6.61,5.34 c0.14,0.14-0.73,0.9-0.87,1.04l-5.02,5.54c-0.24,0.37-0.38-2.26-0.38-2.63l-0.29-1.82c0-0.2,0.15,0.15,0.15,0.15 c-1.98,0.04-2.84,0.13-3.76,0.83c-1.01,0.74-1.69,1.73-2.39,2.84c-0.07,0.12-0.15,0.23-0.22,0.36c-0.62,0.99-1.66,1.58-2.67,2.36 c-1.08,0.83-1,0.77-4.77,1.23c-0.22,0.03-0.35-2.75-0.31-2.08L-0.69,15.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceArrowBl);
export default __webpack_public_path__ + "static/media/source_arrow_bl.dfe3cf5b498714bea16a5281ae557aed.svg";
export { ForwardRef as ReactComponent };